
import { Options, Vue } from "vue-class-component";

@Options({
  components: {},
})
export default class HomeView extends Vue {
  private screenshotsList = ["1.png", "2.png", "3.png"];
}
